import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spinner, Modal, Button, Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllTest } from "../../redux/GetAllTestSlice";
import { homeData } from "../../redux/HomeSlice";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";

const Package = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorySlug } = useParams();

  const responseHome = useSelector((state) => state.homeReducer.data);
  const responseHomeLoading = useSelector(
    (state) => state.homeReducer.isLoading,
  );
  const allTestResponse = useSelector((state) => state.getAllTestReducer.data);
  const allTestLoading = useSelector(
    (state) => state.getAllTestReducer.isLoading,
  );

  const [allTest, setAllTest] = useState([]);
  const [homeData2, setHomeData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const titleMap = {
    0: "Best Laboratory tests near me in Mohali - Kior Healthcare",
    1: "Best CT Scan Hospital in Mohali – Advanced CT Imaging at Kior Healthcare",
    2: "Best MRI Scan in Mohali – Advanced MRI Imaging at Kior Healthcare",
    3: "Best Ultrasound Scan in Mohali – Kior Healthcare",
    4: "Digital X-Ray, Mammography & BMD Services in Mohali – Kior Healthcare",
    5: "Health Checkup Packages in Mohali",
    6: "Best Cardiology Test in Mohali – Kior Healthcare",
    7: "ECG Test in Mohali",
  };
  const h1Desc = {
    0: "If you are searching for the Best Laboratory tests near me in Mohali, Kior Healthcare offers comprehensive and accurate diagnostic solutions under one roof. As a trusted Diagnostic centre, we provide a full range of pathology and clinical investigations supported by advanced equipment and strict quality protocols. Recognised as a NABL-certified lab in Mohali, we follow standardized testing procedures to ensure precise and dependable results for every patient. Whether you need routine screenings or specialized investigations, our facility is a convenient choice for anyone looking for a Medical laboratory near me or a Diagnostic lab near me in Mohali.",
    1: "Looking for the best CT scan hospital in Mohali? Kior Healthcare delivers cutting-edge CT imaging services with state-of-the-art diagnostic technology for quick, accurate and dependable scans. Our centre is created to protect patients, for your comfort and reliable diagnosis to guide doctors in diagnosing diseases with certainty. Kior Healthcare is trusted by patients and doctors across Mohali and Tricity.",
    2: "Looking for the best MRI scan in Mohali? Kior Healthcare offers advanced MRI scanning with up-to-date diagnostic technology for detailed, precise scans. Our centre is built around patient comfort, safe scanning techniques and accurate reporting to enable doctors to make clinical decisions with confidence. With expert Radiologists in our team, we have made a name for ourselves as one of the best MRI scan centres in Mohali. Patients and healthcare professionals both rely on us regionally.",
    3: "",
    4: "Kior Healthcare provides Digital X-Ray Scan in Mohali and makes use of the latest radiology equipment that is focused on quick imaging and precise reporting. We, being the reliable diagnostic lab in the Tricity region, provide advanced imaging and laboratory services using up-to-date equipment under the guidance of an experienced radiology team. We use some of the latest technology in digital X-Ray, Mammography, Ultrasound, CT scans, MRI and full computerised lab testing for complete diagnostic care.",
    5: "If you are looking for comprehensive Health Checkup Packages in Mohali, Kior Healthcare offers advanced and affordable screening solutions designed for early disease detection and preventive care. Our packages are tailored for individuals, families, and corporate employees who want to monitor their overall health with accurate and reliable diagnostics. As a modern diagnostic centre with NABL-standard protocols, we ensure precise testing, hygienic sample collection, and timely report delivery.",
    6: "Maintaining a healthy heart starts with accurate diagnosis, and choosing the Best Cardiology Test in Mohali plays a crucial role in early detection and prevention of serious cardiac conditions. Kior Healthcare is a trusted diagnostic centre offering advanced cardiology tests with a strong focus on accuracy, safety, and patient comfort. Our facility is equipped with modern diagnostic technology and follows strict quality protocols to deliver reliable results you can trust. We provide essential heart investigations such as ECG, 2D Echo, TMT (Stress Test), Holter Monitoring, Lipid Profile, and other cardiac screening tests. These tests help identify heart-related issues like blocked arteries, irregular heartbeats, hypertension-related risks, and early signs of heart disease, enabling timely medical intervention.",
    7: "If you are searching for an accurate and reliable ECG Test in Mohali, Kior Healthcare provides advanced cardiac diagnostics with precision and expert supervision. An Electrocardiogram (ECG) measures the electrical activity of the heart and helps detect irregular heartbeat, heart blockages, chest pain causes, and other cardiovascular conditions. Our modern diagnostic centre ensures quick testing, minimal waiting time, and accurate reporting to support timely medical decisions.",
  };

  const h2Title = {
    0: "Affordable Blood Test in Mohali",
    1: "CT Scan Nearby in Mohali with Advanced Diagnostic Technology",
    2: "Best MRI Scan Center in Mohali with Advanced Technology",
    3: "Advanced Ultrasound Centre in Mohali for Accurate Diagnosis",
    4: "Digital X-Ray Scan in Mohali – Fast & Accurate Imaging",
    5: "Full Body Test in Mohali",
    6: "Affordable Heart Tests in Mohali",
    7: "EEG Test in Mohali",
  };

  const h2Desc = {
    0: "We are committed to delivering an Affordable Blood Test in Mohali without compromising on accuracy. Our services include CBC, thyroid profile, lipid profile, diabetes tests, liver and kidney function tests, and preventive health packages. As a reliable Nearby pathology lab Mohali, we ensure hygienic sample collection, minimal waiting time, and fast report delivery.",
    1: "If you are looking for a CT scan nearby in Mohali, Kior Healthcare is the best for online booking, patient-friendly scanning facilities and shortest report time. Our state-of-the-art CT scanning systems provide an accurate diagnosis of brain disease, chest infections, internal injury, bone fractures and abdominal conditions.",
    2: "Kior Healthcare is equipped with modern MRI systems that help diagnose neurological disorders, spine problems, joint injuries, and internal organ conditions with high clarity and precision. Our skilled radiology team ensures each scan is performed with care, accuracy, and clinical expertise while maintaining patient safety and comfort.",
    3: "Kior Healthcare is known for quality imaging and is considered the best ultrasound scan in Mohali to ensure accurate and safe diagnosis. At our centre, patients in Mohali and Tricity receive care from advanced ultrasound technology and skilled radiologists. We are specialists in early diagnosis and pregnancy monitoring with detailed organ analysis. We have highly experienced professionals who put everything into getting the right solution to the clinician’s needs. We are also a reputable ultrasound centre in Punjab known for offering professional diagnostic imaging services using state-of-the-art medical equipment and uniform quality control measures. We focus on accurate reporting and patient-oriented testing for the individual, family practitioner.Our facility provides a wide range of diagnostic imaging including CT Scan, MRI, Digital X-Ray, Mammography, Ultrasound, and Colour Doppler, supported by a fully computerized laboratory system for fast and secure report delivery.",
    4: "Our Digital X-Ray technology provides high-resolution images with reduced radiation exposure and faster report turnaround. It helps diagnose fractures, infections, lung conditions, and joint abnormalities with precision. At Kior Healthcare, every scan is performed using standardized protocols to maintain accuracy and clinical reliability.",
    5: "Our Full Body Test in Mohali includes a comprehensive panel of essential investigations such as CBC, liver function test (LFT), kidney function test (KFT), lipid profile, blood sugar, thyroid profile, and vitamin screening. These tests help assess organ function, detect nutritional deficiencies, and identify early risk factors for chronic conditions like diabetes and heart disease.",
    6: "At Kior Healthcare, we believe quality cardiac care should be accessible to everyone. That’s why we offer Affordable Heart Tests in Mohali without compromising on diagnostic standards. Our transparent pricing, minimal waiting time, hygienic environment, and fast report delivery make us a preferred choice for preventive and diagnostic heart care. Whether you need a routine heart check-up or tests recommended by your doctor, Kior Healthcare is committed to delivering dependable, affordable, and patient-focused cardiology diagnostics for long-term heart health.",
    7: "Along with cardiac diagnostics, we offer specialized EEG tests to monitor brain activity. EEG (Electroencephalogram) is commonly recommended for patients experiencing seizures, epilepsy, migraines, sleep disorders, or neurological symptoms. Our trained professionals ensure safe procedures and reliable results for effective diagnosis and treatment planning.",
  };
  const h22Title = {
    0: "Reliable laboratory tests near me   ",
    1: "Affordable CT Scan Price in Mohali with Reliable Reporting",
    2: "MRI Scan Near Chandigarh with Reliable and Fast Reporting",
    3: "Comprehensive Ultrasound Services & Fetal Echo Test in Mohali",
    4: "Mammography Test Near Me – Early Breast Health Screening",
    5: "Preventive Health Checkup in Mohali",
    6: "",
    7: "NCV Test in Mohali",
  };

  const h22Desc = {
    0: "For patients seeking Reliable laboratory tests near me, Kior Healthcare combines affordability, certified standards, and expert supervision—making us a dependable healthcare partner for families across Mohali.",
    1: "Understanding patient needs, we offer transparent and competitive CT scan prices in Mohali without compromising diagnostic quality. Our focus is to provide accessible and reliable CT imaging supported by skilled radiology professionals and modern infrastructure.\nAt Kior Healthcare, we combine advanced CT technology, expert medical professionals, and a patient-first approach to deliver trusted diagnostic imaging services across Mohali, Chandigarh, and the Tricity region.",
    2: "Whether you are looking for an MRI scan near Chandigarh, get easy access to convenient appointment booking, no waiting time & expert report delivery at Kior Healthcare. We adhere to quality standards to provide you with safe and accurate results that further assist in your treatment. At Kior Healthcare, we bring together cutting-edge imaging equipment with specialist medical staff and a focus on patients for trusted MRI diagnostic services in Mohali, Chandigarh and the Tricity.",
    3: "Ultrasound scans use sound waves to create real-time images of internal organs and developing fetus during pregnancy. These scans help diagnose medical conditions, monitor organ function, and support prenatal care planning. At Kior Healthcare, specialized pregnancy scans including Fetal Echo Test in Mohali help evaluate fetal heart structure and blood flow, supporting early detection of congenital heart conditions and monitoring high-risk pregnancies.",
    4: "Kior Healthcare offers Digital X-Ray Scan in Mohali using advanced radiology systems designed for fast imaging and accurate reporting. equipped with an advanced radiology system, providing quick imaging results and accurate reports. Providing Mammography in Mohali by expert doctors with advanced machines. Our advanced mammography technology helps physicians diagnose early, which can lead to less invasive treatments. Mammography is indeed a key screening modality, particularly for women outside of the recommended screening age or who are at higher than average risk.",
    5: "A Preventive Health Checkup in Mohali is crucial for maintaining long-term wellness. Regular health screening supports early diagnosis, reduces medical risks, and enables timely treatment. At Kior Healthcare, we combine advanced technology, accurate diagnostic reports, and patient-focused care—making us a trusted choice for complete health screening in Mohali.",
    6: "",
    7: "We also provide advanced NCV (Nerve Conduction Velocity) testing to evaluate nerve damage and muscle response. This test is essential for diagnosing neuropathy, nerve compression, and other neurological disorders. At Kior Healthcare, we combine advanced technology, NABL-standard protocols, and patient-focused care—making us a trusted diagnostic partner in Mohali.",
  };

  const slugify = (text) =>
    text
      ?.toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-") || "";

  useEffect(() => {
    dispatch(homeData());
  }, [dispatch]);

  useEffect(() => {
    if (responseHome?.status === 1) {
      const data = responseHome.data;
      const categories = (data?.categories || []).map((c) => ({
        ...c,
        slug: c.slug || slugify(c.name),
      }));
      setHomeData({ ...data, categories });
       const cateSlug = categorySlug==undefined?categorySlug:categorySlug.replace(/-mohali$/, "")
      const selectedBySlug = cateSlug
        ? categories.find(
            (c) => c.slug === cateSlug || c._id === cateSlug,
          )
        : null;

      const defaultCategoryId = selectedBySlug?._id || categories?.[0]?._id;
      if (defaultCategoryId) {
        dispatch(getAllTest(defaultCategoryId));
      }

      const index = categories?.findIndex((c) => c._id === defaultCategoryId);
      setSelectedIndex(index >= 0 ? index : 0); 
    }
  }, [responseHome, categorySlug, dispatch]);

  useEffect(() => {
    if (allTestResponse?.status === 1) {
      setAllTest(allTestResponse.data);
    }
  }, [allTestResponse]);

  const clickOnCategory = (index, cat) => {
    setSelectedIndex(index);
    const slug = cat.slug || slugify(cat.name);
    navigate(`/${slug + "-mohali"}`);
  };

  const addToCart = (item) => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const exists = cart.find((c) => c._id === item._id);
    if (!exists) cart.push(item);
    localStorage.setItem("cart", JSON.stringify(cart));
    setToastMsg("Added to cart");
    setShowToast(true);
  };

  const openDetails = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  return (
    <>
      <Helmet>
        <title>Laboratory Tests Near Me in Mohali | Kior Healthcare</title>
      </Helmet>

      <div className="package">
        {/* ================= CATEGORY TABS ================= */}
        <div className="package_tabs">
          <div className="container">
            <div className="tabs_wrapper">
              {/* {homeData2?.categories?.map((item, index) => (
                <button
                  key={item._id}
                  className={index === selectedIndex ? "active" : ""}
                  onClick={() => clickOnCategory(index, item)}
                >
                  {item.name}
                </button>
              ))} */}
            </div>
          </div>
        </div>

        {/* ================= HERO ================= */}
        <div className="package_hero">
          {/* <div className="container"> */}
          {/* <h1>{homeData2?.categories?.[selectedIndex]?.name}</h1> */}
          <h1>{titleMap[selectedIndex]}</h1>
          <p>{h1Desc[selectedIndex]}</p>
          {/* </div> */}
        </div>

        {/* ================= DESCRIPTION ================= */}
        <div className="package_description">
          <div className="container">
            <div className="desc_box">
              <h2>{h2Title[selectedIndex]}</h2>
              <p>{h2Desc[selectedIndex]}</p>
              <h2>{h22Title[selectedIndex]}</h2>
              <p>{h22Desc[selectedIndex]}</p>
            </div>
          </div>
        </div>

        {/* ================= PACKAGES ================= */}
        <div className="container package_grid">
          <Row className="g-4">
            {responseHomeLoading || allTestLoading ? (
              <div className="text-center w-100 py-5">
                <Spinner animation="border" />
              </div>
            ) : (
              allTest?.map((item) => (
                <Col lg={4} md={6} key={item._id}>
                  <Card className="package_card">
                    <Card.Body>
                      <h6 className="title">{item.name}</h6>
                      <div className="price">₹ {item.amount}</div>

                      <div className="actions">
                        <Button
                          className="btn_primary"
                          onClick={() => addToCart(item)}
                        >
                          Add to Cart
                        </Button>
                        <Button
                          variant="link"
                          className="btn_link"
                          onClick={() => openDetails(item)}
                        >
                          Know More →
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            )}
          </Row>
        </div>

        {/* MODAL */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{modalData?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{modalData?.description}</p>
            <p>
              <strong>Price:</strong> ₹ {modalData?.amount}
            </p>
          </Modal.Body>
        </Modal>

        {/* TOAST */}
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={2000}
          autohide
          style={{ position: "fixed", right: 20, bottom: 20 }}
        >
          <Toast.Body>{toastMsg}</Toast.Body>
        </Toast>
      </div>
    </>
  );
};

export default Package;
